/**
 * @desc 分页
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<
  defs.basics.IPage<defs.basics.PlmMaterialCategoryResponseDto>
>;
export function request(
  params: API.basics.plmMaterialCategory.page.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/plmMaterialCategory/page`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
